import { render, staticRenderFns } from "./adminizin.vue?vue&type=template&id=693c5292"
import script from "./adminizin.vue?vue&type=script&lang=js"
export * from "./adminizin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports